import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { setFieldValidationState } from "../slices/formSlice";
import { updateField } from "../slices/formSlice";
import { clearFieldError } from "../slices/formSlice";
import { setFieldError } from "../slices/formSlice";

export const useFieldValidation = (formId, name, label, validationRules, type) => {
    const dispatch = useDispatch();
    const rawValue = useSelector((state) => state.form.forms[formId]?.values[name]);
    const value = rawValue !== undefined ? rawValue : (type === "multiselect" || type === "string_array" ? [] : "");
    const error = useSelector((state) => state.form.forms[formId]?.errors[name]);

    const isEmptyValue = (val) =>
        val === null ||
        val === undefined ||
        (typeof val === "string" && val.trim() === "") ||
        (Array.isArray(val) && val.length === 0) ||
        (typeof val === "object" && !Array.isArray(val) && Object.keys(val).length === 0);

    const validate = (newValue) => {
        if (newValue === undefined || newValue === null) {
            newValue = "";
        }

        let isEmpty = false;

        if (validationRules?.required) {
            isEmpty = isEmptyValue(newValue);
        }

        dispatch(setFieldValidationState({ formId, fieldName: name, isEmpty }));

        if (isEmpty) {
            dispatch(setFieldError({ formId, fieldName: name, error: 'Это обязательное поле' }));
        } else {
            dispatch(clearFieldError({ formId, fieldName: name }));
        }

        return isEmpty;
    };

    const handleChange = (newValue) => {
        if (JSON.stringify(value) === JSON.stringify(newValue)) {
            return;
        }

        dispatch(updateField({ formId, fieldName: name, value: newValue }));
        validate(newValue);
    };

    return { value, error, handleChange, validate };
}